export function CustomLoader({ loadingPercentage }) {
	return (
		<div
			style={{
				position: "fixed",
				top: "0",
				left: "0",
				width: "100vw",
				height: "100vh",
				backgroundColor: "#ffffff59", // Overlay effect
				zIndex: "99999",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			{loadingPercentage !== 0 && (
				<p
					style={{ color: "rgb(104, 104, 104)" }}
				>{`Loading: ${loadingPercentage}%`}</p>
			)}

			<div className="custom-loader">
				<div
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						height: "100%",
						width: `${loadingPercentage}%`, // Foreground loader showing progress
						backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent to let the animation show behind it
						borderRadius: "inherit",
					}}
				/>
			</div>
		</div>
	);
}